import React, { useState, useEffect } from 'react'

const DeviceSimulator = ({ onStartTrip, onStopTrip, currentTrip, userProfile, sensorStatus }) => {
  const [deviceName, setDeviceName] = useState('My Device')
  const [vehicleType, setVehicleType] = useState('personal')

  useEffect(() => {
    if (userProfile) {
      setDeviceName(`${userProfile.username}'s Device`)
      setVehicleType(userProfile.vehicle_type || 'personal')
    }
  }, [userProfile])

  const handleStart = () => {
    onStartTrip({ name: deviceName, type: vehicleType })
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Device Simulator</h3>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Device Name</label>
          <input
            type="text"
            value={deviceName}
            onChange={(e) => setDeviceName(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
            disabled={currentTrip}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Vehicle Type</label>
          <select
            value={vehicleType}
            onChange={(e) => setVehicleType(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
            disabled={currentTrip}
          >
            <option value="personal">Personal</option>
            <option value="car">Car</option>
            <option value="bike">Bike</option>
            <option value="scooter">Scooter</option>
            <option value="boat">Boat</option>
            <option value="drone">Drone</option>
          </select>
          <p className="text-xs text-gray-500 mt-1">
            Default from your profile: {userProfile?.vehicle_type || 'personal'}
          </p>
        </div>
        {!currentTrip ? (
          <button
            onClick={handleStart}
            className="w-full bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500"
          >
            Start Movement
          </button>
        ) : (
          <button
            onClick={onStopTrip}
            className="w-full bg-red-600 text-white py-2 px-4 rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
          >
            Stop Movement
          </button>
        )}
        <p className="text-sm text-gray-500 text-center">
          {!currentTrip 
            ? "Start movement to begin tracking your trip"
            : "Trip in progress... Real-time tracking active"}
        </p>
      </div>
    </div>
  )
}

export default DeviceSimulator